/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerSkipBack = createReactComponent("outline", "player-skip-back", "IconPlayerSkipBack", [["path", { "d": "M20 5v14l-12 -7z", "key": "svg-0" }], ["path", { "d": "M4 5l0 14", "key": "svg-1" }]]);

export { IconPlayerSkipBack as default };
//# sourceMappingURL=IconPlayerSkipBack.mjs.map
